export const RQ_NOTIFICATIONS_KEY = ['notifications'];

export const NOTIFICATIONS_POLLING_INTERVAL = 60_000;
